import View from '../core/View';
import DropdownMenuView from './DropdownMenuView';
import LibraryInfoView from './LibraryInfoView';

export default class LibraryToolbarView extends View {

    createView(model) {

        let library = model['library'];

        let toolbarDOM = $('<div>', {
            class: 'toolbar',
            style: `padding: 8px; background-color: ${library.visualTemplate.toolbarBackgroundColor}; text-align: center;`
        });

        let menuJson = {};

        if (this.app.cds) {
            let textLogin = this.app.polyglot.t("Login");
            let textLogout = this.app.polyglot.t("Logout");

            if (this.app.cdsConfig.cdsUsername.length == 0)
                menuJson[textLogin] = function() { this.login(); }.bind(this);
            else
                menuJson[textLogout] = function() { this.logout(); }.bind(this);
        }

        if (library.visualTemplate.showSearchButton) {
            let btnName = this.app.polyglot.t("Search");
            menuJson[btnName] = function() {
                $('#searchModal').on('shown.bs.modal', function () {
                    $('#searchInput').focus();
                }).modal('show');
            }.bind(this);
        }

        if (library.visualTemplate.showChangeLanguageButton) {
            let btnName = this.app.polyglot.t("Languages");
            menuJson[btnName] = {
                'Español': function() { this.changeLanguage('es');}.bind(this),
                'English': function() { this.changeLanguage('en'); }.bind(this),
                'Chino': function() { this.changeLanguage('zh'); }.bind(this)
            };
        }

        if (library.appUrl && library.appUrl.length > 0) {
            let btnName = this.app.polyglot.t("Web");
            menuJson[btnName] = function() {
                window.open(library.appUrl, '_blank');
            }.bind(this);
        }

        if (library.visualTemplate.horizontalLibraryInfoImages.length > 0 ||
            library.visualTemplate.verticalLibraryInfoImages.length > 0) {

            let btnName = this.app.polyglot.t("Help");
            menuJson[btnName] = function() {
                this.app.createView(new LibraryInfoView(), {
                    'visualTemplate': library.visualTemplate
                });
            }.bind(this);

        }

        if (!$.isEmptyObject(menuJson)) {
            this.app.createView(new DropdownMenuView(), {
                'menuJson': menuJson,
                'visualTemplate': library.visualTemplate
            }).appendTo(toolbarDOM);
        }

        if (this.app.cds && this.app.cdsConfig.cdsUsername.length > 0) {
            $('<div>', {
                text: this.app.cdsConfig.cdsUsername,
                css: {
                    'float': 'right',
                    'color': library.visualTemplate.toolbarTintSecondaryColor,
                    'font-weight': 'bold'
                }
            }).appendTo(toolbarDOM);
        }

        // Toolbar title
        $('<h1>', {
            css: {
                'margin': '0px',
                'font-size': '1.4em',
                'color': `${library.visualTemplate.toolbarTintColor}`
            },
            text: `${library.title}`
        }).appendTo(toolbarDOM);

        $('<div>', {
            css: {
                'clear': 'both'
            }
        }).appendTo(toolbarDOM);

        return toolbarDOM;

    }

    changeLanguage(lang) {
        this.app.changeCurrentLanguage(lang);
    }

    login() {
        let textUsername = this.app.polyglot.t("Username");
        let textPassword = this.app.polyglot.t("Password");
        let textRemember = this.app.polyglot.t("Remember");
        let textLogin = this.app.polyglot.t("Login");

        $('#loginDialog').remove();

        let d = $('<div>', {
            id: 'loginDialog',
            title: textLogin,
            html: '<label for="login_username">'+textUsername+':</label><br/><input type="text" id="login_username"/><br/>' +
            '<label for="login_password">'+textPassword+':</label><br/><input type="password" id="login_password"/><br/>' +
            '<input type="checkbox" id="login_remember"><label for="login_remember" style="margin-left:5px;">'+textRemember+'</label>',
            keypress: function(e) {
                if (e.keyCode == $.ui.keyCode.ENTER) {
                    $('#loginButton').trigger("click");
                }
            }
        }).dialog({
            modal: true,
            buttons: [
                {
                    id: 'loginButton',
                    text: textLogin,
                    click: () => {
                        let username = d.children('#login_username').val();
                        let password = d.children('#login_password').val();
                        let remember = d.children('#login_remember').is(':checked');

                        if (username.length > 0 || password.length > 0) {
                            $('#loginDialog').dialog("close");
                            this.app.login(username, password, remember);
                        }
                    }
                }
            ]
        });
    }

    logout() {
        this.app.logout();
    }

}
